import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { EventService } from './event.service';
import { BehaviorSubject } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class LanguageService {
  public languages: string[] = ['en', 'he', 'ar'];
  private langSubject: BehaviorSubject<string> = new BehaviorSubject(
    this.cookieService.get(environment.languageCookieKey) || 'he',
  );
  public $langObservable = this.langSubject.asObservable();
  constructor(
    public translate: TranslateService,
    private cookieService: CookieService,
    private eventService: EventService,
  ) {
    this.translate.addLangs(this.languages);
    // if (this.cookieService.check(environment.languageCookieKey)) {
    //   browserLang = this.cookieService.get(environment.languageCookieKey);
    // } else {
    //   browserLang = translate.getBrowserLang();
    // }
    const browserLang = this.cookieService.get(environment.languageCookieKey) || 'he';

    translate.use(browserLang?.match(/en|he|ar/) ? browserLang : 'he');
    if (this.translate.currentLang === 'he' || this.translate.currentLang === 'ar') {
      this.changeDirection('rtl');
    } else {
      this.changeDirection('ltr');
    }
  }

  /***
   * Cookie Language set
   */
  public setLanguage(lang: any) {
    this.translate.use(lang);
    this.eventService.broadcast('changeLanguage', lang);
    this.cookieService.set(environment.languageCookieKey, lang, { path: '/', expires: environment.cookieExpireTime });
    if (lang === 'he' || lang === 'ar') {
      this.changeDirection('rtl');
    } else {
      this.changeDirection('ltr');
    }
    this.langSubject.next(lang);
  }

  changeDirection(mode: string) {
    document.documentElement.setAttribute('dir', mode);
    this.eventService.broadcast('changeDirection', mode);
  }
  public getCurrentLang() {
    return this.cookieService.get(environment.languageCookieKey).trim() || 'he';
  }

  setLanguageForBusinessPortal() {
    const lang = this.cookieService.get(environment.languageCookieKey);
    this.setLanguage(lang);
  }
}
